import React, { useEffect, useState } from 'react';
import riyaz from '../images/Dr Riyaz Photo 4.jpeg'
import poorna from '../images/poornasir1.jpg'
import venkat from '../images/Venkat_updatedimg.png'
import wang from '../images/xinhu-wang-smaller.jpg'
import antony from '../images/antony.jpeg'
import Aiicon from '../images/Ai ICON.png'
import { FaLinkedin } from 'react-icons/fa';
// import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import Anil from "../images/Anil Kumar-centella.jpeg"
import jeevan from '../images/jeevan.jpeg'





const AboutUs = () => {

  const [showPopup, setShowPopup] = useState(false);
  const [selectedFounder, setSelectedFounder] = useState(null);

  const founders = [
    {
      name: 'Dr. Riyaz Syed',
      designation: 'Founder & CEO',
      image: riyaz,
      description: `
      Dr. Riyaz is a distinguished scientist with a Ph.D. in Medicinal Chemistry and over 15 years of experience in cancer drug discovery.
      He has a proven track record in designing small molecules targeting kinases and protein degradation (PROTAC), credited with 50 publications and three patents, including a joint patent with Harvard Medical School and NUS Singapore.
     
      His expertise spans knowledge-based drug design, Structure-Based Drug Design (SBDD), Ligand-Based Drug Design (LBDD), retrosynthesis, Structure-Activity Relationship (SAR) analysis, patent space exploration, and effective grant writing.
      Dr. Riyaz has led international collaborations, managed multi-disciplinary teams, and executed projects with CRO and CRAMS.
 
      Dr. Riyaz also has significant management experience in startups, from ideation to MVP development, business model generation, investor pitching, and marketing strategy.
      He holds certifications in Business & Strategy from Wharton Business School, Harvard University, and IIM Bangalore.
 
      He has worked as a Consulting Scientist, Scientific Advisor, CSIR-Pool Scientist, Post-Doctoral Research Associate, and Junior Scientist, contributing extensively to research and development in cancer therapeutics.
    `,
      linkedin: 'https://www.linkedin.com/in/dr-riyaz-syed',
    },
    {
      name: 'Dr. Poornachandra',
      designation: 'Co-Founder, Head - Molecular Biology',
      image: poorna,
      description: 'Dr. Poornachandra brings over a decade of experience in cancer biology, molecular biology, drug discovery, and precision medicine to his role as co-founder and Director of the Biology Division at Centella. Dr. Poornachandra holds a Ph.D. from the Indian Institute of Chemical Technology, Hyderabad, where his research focused on nanobiotechnology and chemical biology. He successfully fabricated and characterized metal nanoparticles with potential anti-proliferative and anti-microbial properties. Additionally, his doctoral work explored the development of drug carrier systems for targeted cancer therapy and the screening of chemical libraries against various anti-cancer targets, including mechanistic studies.',
      linkedin: 'https://www.linkedin.com/in/dr-poornachandra',
    },

    // {
    //   name: 'Dr.Xinhui Wang',
    //   designation: 'Harvard Medical School, Mass General Hospital',
    //   image: wang,
    //   description: 'Dr. Xinhui Wang brings deep expertise in cancer biology and solid tumor immunotherapy, guiding Centella’s AI-driven drug discovery toward clinically relevant, translationally viable therapies in oncology.',
    //   linkedin: 'https://www.linkedin.com/in/xinhui-wang-5a6751168/',
    // },

  ];

  const handleLinkedinClick = (founder) => {
    setSelectedFounder(founder);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedFounder(null);
  };


  // Inside your component
  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = 'hidden'; // Prevent background scroll
    } else {
      document.body.style.overflow = 'auto'; // Restore when popup closes
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showPopup]);


  return (
    <>
      {/* <div className="bg-gradient-to-r from-black to-[#212337] text-white px-6 sm:px-12 lg:px-24"> */}
      <div className="bg-black text-white px-6 sm:px-12 lg:px-24">
        <div className="mx-auto px-4 sm:px-8 py-12 tracking-[1px] opacity-75 font-sofia">
          {/* Company Description */}
          <section className="flex flex-col items-center justify-center mb-12 max-w-5xl mx-auto">
            <div className="w-full text-center">
              <h2 className="text-6xl sm:text-5xl lg:text-6xl font-bold mb-4 text-[#6FC5F0]">
                Our Team
              </h2>
              <hr className="border-t-2 border-[#6FC5F0] w-full" />
            </div>
          </section>



          {/* Our Commitment */}
          <section className="flex flex-col items-center justify-center mb-12 max-w-6xl mx-auto">
            <div className="w-full text-center">
              {/* <hr className="border-t-2 border-[#6FC5F0] w-full mb-4" /> */}
            </div>
            <div className="w-full px-6"> {/* Adjusted padding */}
              <p className="text-lg text-white sm:text-md lg:text-lg leading-relaxed text-justify text-black">
                Centella AI team consists of over 20 professionals, including Data Scientists, Molecular Biologists, Medicinal Chemists,Informaticians and AI Engineers, bringing together a diverse range of scientific disciplines with deep experience in the drug discovery industry. We are committed to developing cutting-edge therapeutics, reinforcing our global impact on healthcare.
              </p>
            </div>
          </section>




          {/* Meet Our Founders */}
          <section className="text-center mb-12">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 justify-items-center">
              {/* Founder 1 */}

              {/* Founder 1 */}
              <div className="flex flex-col items-center max-w-lg">
                <motion.div className="flex flex-col items-center max-w-lg"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}>
                  <img
                    src={riyaz}
                    alt="Dr. Riyaz Syed"
                    className="w-48 h-48 mb-4 object-cover rounded-full"
                    onClick={() => handleLinkedinClick(founders[0])}
                  />
                  <div className="text-center"> {/* Change to text-center for centering */}
                    <h3 className="text-3xl font-bold">Dr. Riyaz Syed</h3>
                    <p className="text-cyan-400 text-2xl">Founder & CEO</p>
                    <div className="flex justify-center mt-2"> {/* Change to justify-center for centering */}
                      <a
                        className="text-teal-400 hover:text-teal-600 cursor-pointer"
                        href='https://www.linkedin.com/in/dr-riyaz-syed-b1163b4/'
                      >
                        <FaLinkedin size={24} />
                      </a>
                    </div>
                  </div>
                </motion.div>

              </div>


              {/* Founder 2 */}
              <div className="flex flex-col items-center max-w-lg">
                <motion.div className="flex flex-col items-center max-w-lg"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}>
                  <img
                    src={poorna}
                    alt="Dr. Poornachandra"
                    className="w-48 h-48 mb-4 object-cover cursor-pointer rounded-full"
                    onClick={() => handleLinkedinClick(founders[1])}
                  />
                  <div className="text-center"> {/* Change to text-center for centering */}
                    <h3 className="text-3xl font-bold">Dr. Poornachandra</h3>
                    <p className="text-cyan-400 text-2xl">Co-Founder & Chief Scientist</p>
                    <div className="flex justify-center mt-2"> {/* Change to justify-center for centering */}
                      <a
                        className="text-teal-400 hover:text-teal-600 cursor-pointer"
                        href='https://www.linkedin.com/in/dr-poornachandra-y-1408b847/'
                        target='_blank'
                        rel="noreferrer"
                      >
                        <FaLinkedin size={24} />
                      </a>
                    </div>
                  </div>
                </motion.div>
              </div>


            <div className="flex flex-col items-center max-w-xs">
                              <motion.div className="flex flex-col items-center max-w-lg"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }}>
                                <img
                                  src={jeevan}
                                  alt="antony"
                                  className="w-48 h-48 rounded-full mb-4 object-cover"
                                />
                                <div className="text-center">
                                  <h3 className="text-3xl font-bold">Jeevan Rebba</h3>
                                  <p className="text-cyan-400 text-2xl">Chief Strategy Officer</p>

                                  <a
                                    className="text-teal-400 flex justify-center mt-2 hover:text-teal-600 cursor-pointer"
                                    href='https://www.linkedin.com/in/jeevanrebba/'
                                    target='_blank'
                                    rel="noreferrer"
                                  >
                                    <FaLinkedin size={24} />
                                  </a>

                                </div>
                              </motion.div>
              </div>

            <div className="flex flex-col items-center max-w-xs">
                  <motion.div className="flex flex-col items-center max-w-lg"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}>
                    <img
                      src={Anil}
                      alt="antony"
                      className="w-48 h-48 rounded-full mb-4 object-cover"
                    />
                    <div className="text-center">
                      <h3 className="text-3xl font-bold">Anil Kumar</h3>
                      <p className="text-cyan-400 text-2xl">Head - Strategic Partnerships & Alliances</p>

                      <a
                        className="text-teal-400 flex justify-center mt-2 hover:text-teal-600 cursor-pointer"
                        href='https://www.linkedin.com/in/anil-kumar-growth-leader/'
                        target='_blank'
                        rel="noreferrer"
                      >
                        <FaLinkedin size={24} />
                      </a>

                    </div>
                  </motion.div>
                </div> 

            </div>


            {/* Popup Modal */}
            {/* Popup Modal */}
            {showPopup && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 overflow-y-auto">
                <div className="bg-white p-6 rounded-lg max-w-md w-full m-4">
                  <div className="flex flex-col items-center">
                    <img
                      src={selectedFounder.image}
                      alt={selectedFounder.name}
                      className="w-48 h-48 mb-4 object-cover rounded-full"
                    />
                    <h3 className="text-2xl font-bold text-black text-center">
                      {selectedFounder.name}
                    </h3>
                    <p className="text-black text-lg text-center">{selectedFounder.designation}</p>
                    <p className="mt-4 text-black text-sm text-justify max-h-60 overflow-y-auto">
                      {selectedFounder.description}
                    </p>

                    <div className="flex justify-center mt-4">
                      <a
                        href={selectedFounder.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-teal-500 hover:text-teal-600 underline"
                      >
                        LinkedIn Profile
                      </a>
                    </div>

                    <button
                      onClick={closePopup}
                      className="mt-6 bg-teal-500 hover:bg-teal-600 text-white py-2 px-5 rounded"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

          </section>


          {/* Meet our advisors  */}
          <section >
            <div className="flex flex-col gap-12 mt-24">
              {/* Row 1 */}
              <div className="flex flex-wrap justify-around gap-8">
                {/* Team Member 1 */}
                <div className="flex flex-col items-center max-w-xs">
                  <motion.div className="flex flex-col items-center max-w-lg"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}>
                    <img
                      src={venkat}
                      alt="Venkat"
                      className="w-48 h-48 rounded-full mb-4 object-cover"
                    />
                    <div className="text-center">
                      <div className="text-3xl font-bold">Venkat N</div>
                      <p className="text-cyan-400 text-2xl"> Technology Advisor</p>
                      <div className="flex justify-center mt-2"> {/* Change to justify-center for centering */}
                        <a
                          className="text-teal-400 hover:text-teal-600 cursor-pointer"
                          href='https://www.linkedin.com/in/venkatin/'
                          target='_blank'
                          rel="noreferrer"
                        >
                          <FaLinkedin size={24} />
                        </a>
                      </div>
                    </div>
                  </motion.div>
                </div>
                {/* Team Member 2 */}
                <div className="flex flex-col items-center max-w-xs">
                  <motion.div className="flex flex-col items-center max-w-lg"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}>
                    <img
                      src={wang}
                      alt="wang"
                      className="w-48 h-48 rounded-full  cursor-pointer mb-4 object-cover overflow-hidden"
                      onClick={() => handleLinkedinClick(founders[2])}
                    />
                    <div className="text-center">
                      <h3 className="text-3xl font-bold">Dr.Xinhui Wang</h3>
                      <p className="text-cyan-400 text-2xl">Harvard Medical School, Mass General Hospital</p>
                      <div className="flex justify-center mt-2"> {/* Change to justify-center for centering */}
                        <a
                          className="text-teal-400 hover:text-teal-600 cursor-pointer"
                          href='https://www.linkedin.com/in/xinhui-wang-5a6751168/'
                          target='_blank'
                          rel="noreferrer"
                        >
                          <FaLinkedin size={24} />
                        </a>
                      </div>
                    </div>
                  </motion.div>
                </div>
                {/* Team Member 3 */}
                <div className="flex flex-col items-center max-w-xs">
                  <motion.div className="flex flex-col items-center max-w-lg"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}>
                    <img
                      src={antony}
                      alt="antony"
                      className="w-48 h-48 rounded-full mb-4 object-cover"
                    />
                    <div className="text-center">
                      <h3 className="text-3xl font-bold">Dr. Antonio Brunetti</h3>
                      <p className="text-cyan-400 text-2xl">Scientific Advisor</p>

                      <a
                        className="text-teal-400 flex justify-center mt-2 hover:text-teal-600 cursor-pointer"
                        href='https://www.linkedin.com/in/antonio-brunetti-3729b31b/'
                        target='_blank'
                        rel="noreferrer"
                      >
                        <FaLinkedin size={24} />
                      </a>

                    </div>
                  </motion.div>
                </div>
                {/* Team Member 4 */}
                
               
              </div>
            </div>
          </section>

          <section className="text-center mt-16 max-w-3xl mx-auto">
            <div className='flex flex-col items-center justify-center'>
              <img className="text-center  mt-8 animate-pulse" alt='' src={Aiicon} height={140} width={140} />
            </div>


            <div className='mt-12'>
              <span className='flex flex-row items-center justify-center '>
                <img src='https://cdn-icons-png.flaticon.com/128/9664/9664292.png' alt='' height={60} width={60} className='relative mb-12 ' />
                <p className="text-2xl leading-relaxed mx-4 text-center italic">
                  Transforming scientific insights into life-saving therapies
                </p>
                <img className="transform scale-x-[-1] relative mb-12" src='https://cdn-icons-png.flaticon.com/128/9664/9664292.png' alt='' height={60} width={60} />
              </span>
            </div>

          </section>

        </div>

      </div>
      {/* <div>
      <Footer/>
    </div> */}
    </>

  );
};

export default AboutUs;

